import React from 'react';

import { Box } from '@mui/material';

import {
  NO_FILE_LABEL,
  PreviewKind,
  TemplateChangeKind,
  TemplateRequestStatus,
} from '../../FormChangeHistory.constants';
import { TemplateChangesetPropTypes } from '../../FormChangeHistory.propTypes';
import { changesetStyles } from '../../FormChangeHistory.styles';
import {
  getChangePreviewPanes,
  getTemplatePreviewPresence,
  hasTemplatePreview,
} from '../../FormChangeHistory.utils';
import useTemplateChanges from '../../hooks/useTemplateChanges';
import HtmlTemplateFacts from '../HtmlTemplateFacts';
import TemplatePreviewAction from '../TemplatePreviewAction';
import TemplateRequestState from '../TemplateRequestState';

/**
 * The `forms.htmlFile` renderer for an HTML change without a Prism one (a legacy HTML form, or HTML
 * edited outside Prism): the file's facts on both sides, each openable in a sandboxed frame, and
 * both side by side.
 */
const HtmlTemplateChangeset = ({ change, detail }) => {
  const { auditId, status, data, retry } = useTemplateChanges({
    change,
    detail,
    kind: TemplateChangeKind.HTML,
  });

  if (status !== TemplateRequestStatus.LOADED) {
    return (
      <Box sx={changesetStyles}>
        <TemplateRequestState emptyLabel={NO_FILE_LABEL} status={status} onRetry={retry} />
      </Box>
    );
  }

  return (
    <>
      <TemplatePreviewAction
        auditId={auditId}
        isHidden={!hasTemplatePreview(data)}
        kind={PreviewKind.CHANGE}
        occurredAtUtc={detail.summary.occurredAtUtc ?? null}
        panes={getChangePreviewPanes(getTemplatePreviewPresence(data))}
        templateKind={TemplateChangeKind.HTML}
      />
      <HtmlTemplateFacts auditId={auditId} html={data.html} />
    </>
  );
};

HtmlTemplateChangeset.propTypes = TemplateChangesetPropTypes;

export default HtmlTemplateChangeset;
